import {
  Dialog,
  DialogClose,
  DialogContent as DialogContentBase,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

const NESTED_DIALOG_VEIL =
  'data-nested-dialog-open:after:absolute data-nested-dialog-open:after:inset-0 data-nested-dialog-open:after:z-50 data-nested-dialog-open:after:rounded-[inherit] data-nested-dialog-open:after:bg-black/10 data-nested-dialog-open:after:backdrop-blur-xs data-nested-dialog-open:after:animate-in data-nested-dialog-open:after:fade-in-0 data-nested-dialog-open:after:duration-100'

/**
 * The popup is a fixed frame: it never scrolls itself, so the regions inside
 * it (header, body, footer) decide what scrolls.
 */
function DialogContent({
  className,
  ...props
}: React.ComponentProps<typeof DialogContentBase>) {
  return (
    <DialogContentBase
      className={cn(
        'flex max-h-[calc(100dvh-2rem)] flex-col gap-0 overflow-hidden px-0 py-3',
        NESTED_DIALOG_VEIL,
        className,
      )}
      {...props}
    />
  )
}

export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
}
